module.exports = __webpack_public_path__ + "static/img/20018 (4).9a9924d.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20018 (4).webp
// module id = 07wy
// module chunks = 14